var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    {
      attrs: { value: _vm.value, disabled: _vm.disabled, nav: "" },
      on: {
        click: function ($event) {
          return _vm.handleClick()
        },
      },
    },
    [
      _vm.currentBreakpoint > 0
        ? _c(
            "v-list-item-avatar",
            [
              _c("v-icon", { attrs: { centered: "" } }, [
                _vm._v(" " + _vm._s(_vm.icon) + " "),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-list-item-content",
        [
          _vm.currentBreakpoint > 0
            ? _c("v-list-item-title", [_vm._v(" " + _vm._s(_vm.label) + " ")])
            : _c(
                "v-list-item-title",
                { staticClass: "text-center" },
                [
                  _c("v-icon", { attrs: { centered: "" } }, [
                    _vm._v(" " + _vm._s(_vm.icon) + " "),
                  ]),
                ],
                1
              ),
          _vm.currentBreakpoint > 1
            ? _c("v-list-item-subtitle", [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.subLabel) } }),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }